export const getApiBase = () =>
  import.meta?.env?.VITE_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "";

export const resolveImgSrc = (img, API_BASE = getApiBase()) => {
  if (!img) return null;
  if (img instanceof File) return URL.createObjectURL(img);
  const path = String(img).replace(/\\/g, "/");
  if (path.startsWith("http") || path.startsWith("//")) return path;
  return `${API_BASE}${path}`;
};

export const childrenOf = (categories, parentId) =>
  categories.filter((c) => c.parentCategoryId === Number(parentId));

export const getCategoryNameById = (categories, id) => {
  const c = categories.find((x) => x.id === Number(id));
  return c ? c.nameCategor : null;
};

// מחזיר: parentId (רמה1), childId (רמה2), subId (רמה3 או 0)
export const getAncestors = (categories, catId) => {
  const level3 = categories.find((c) => c.id === Number(catId));
  if (!level3) return { parentId: 0, childId: 0, subId: 0 };

  const level2 = categories.find((c) => c.id === Number(level3.parentCategoryId));
  const level1 = level2 ? categories.find((c) => c.id === Number(level2.parentCategoryId)) : null;

  // אם יש סבא -> catId הוא תת-תת
  if (level1) {
    return { parentId: level1.id, childId: level2.id, subId: level3.id };
  }

  // אחרת catId הוא תת-קטגוריה
  return { parentId: level2 ? level2.id : 0, childId: level3.id, subId: 0 };
};

export const buildFormData = (values) => {
  const finalCategoryId =
    values.subCategoryId && Number(values.subCategoryId) !== 0
      ? Number(values.subCategoryId)
      : Number(values.categoryId);

  const fd = new FormData();
  fd.append("name", values.name);
  fd.append("price", String(values.price));
  fd.append("quantity", String(values.quantity));
  fd.append("categoryId", String(finalCategoryId));
  fd.append("description", values.description || "");

  if (values.image instanceof File) {
    fd.append("image", values.image);
  }

  if (values.variationType) {
    const optionsPayload = (values.options || [])
      .filter((o) => o.value && o.value.trim() !== "")
      .map((o) => ({
        OptionType: values.variationType,
        Value: o.value.trim(),
        ExtraPrice: o.extraPrice === "" ? null : Number(o.extraPrice),
        Quantity: o.quantity === "" ? null : Number(o.quantity),
      }));

    fd.append("OptionsJson", JSON.stringify(optionsPayload));
  } else {
    fd.append("OptionsJson", "[]");
  }

  return fd;
};
